import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectSensorDataRestoringRequests = (state: AppState) => state.sensorDataRestoringRequest;

export const getSensorDataRestoringRequests = () =>
  createSelector(selectSensorDataRestoringRequests, (state) => state.requests);
export const getSensorDataRestoringRequestsTotal = () =>
  createSelector(selectSensorDataRestoringRequests, (state) => state.requestsTotal);
export const getFilter = () => createSelector(selectSensorDataRestoringRequests, (state) => state.filter);
